<template>
  <div class="box_pay">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        支付设置
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div @click="getting()" style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" class="filtrate">
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <!-- <router-link to="./add_admin" tag="div" class="center_list_head_rig">添加管理员</router-link> -->
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="pay_name" label="支付方式名称" align="center"></el-table-column>

        <el-table-column
          prop="pay_info"
          label="支付方式描述"
          align="center"
          width="350"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="order_by"
          label="排序"
          align="center"
          :default-sort="{prop: 'date', order: 'descending'}"
        ></el-table-column>
        <el-table-column prop="status" label="禁用/激活" align="center">
          <template slot-scope="scope">
            <el-switch
              @change="tatus($event,scope.row.id)"
              v-model="scope.row.status"
              active-color="rgb(19, 206, 102)"
              inactive-color="#dcdfe6"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column prop="operation" label="操作" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button @click="red(scope.row.id)">编辑</button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>

<script>
export default {
  name: "leftmenu",
  data() {
    return {
      serve: this.$store.state.serve,
      tableData: [],
      topic: [],
      brand: [],
      str: "test",
      username: "",
      token: "",
      router: "",
      menuItems: null,
      style1: {
        height: null
      },
      total: 0,
      current_page: null,
      input: "",
      value: "",
      options: [],
      // tableData: [],
      group_id: 0,
      page: null,
      role: true
    };
  },
  created() {
    this.$store.state.topActiveId = 7;
    this.$store.state.leftTitle = "支付设置";
    this.getting();
  },
  methods: {
    getting() {
      //请求数据
      this.tableData = [];
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/payway_list", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          if(res.data.msg == '无权访问'){
              this.role = false;
          }else{
              var json = res.data.data;
              for (var key in json) {
                if (key >= 0) {
                  that.tableData.push(json[key]);
                }
              }
          }
          
        });
    },
    tatus(v, id) {
      //禁用激活
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/payway_status", {
          params: {
            username: this.username,
            token: this.token,
            id: id
          }
        })

        .then(res => {
          if (res.data.status == "success") {
            if (v == 1) {
              var str = "激活";
            } else {
              var str = "禁用";
            }
            this.$notify({
              title: str + "成功",
              message: "管理员" + str + "成功",
              type: "success"
            });
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          } 
        });
    },

    red(id) {
      //跳转编辑
      this.$router.push({
        path: "/admin/g_redactPay/" + id
      });
    }
  }
};
</script>

<style lang="scss">
.box_pay {
  min-height: 1000px;
  background: #f5f5f5;
  //  padding-bottom: 100px;
  .el-pagination {
    text-align: center;
  }
  .leftMenu {
    float: left;
    width: 180px !important;
    display: block;
    position: absolute;
    height: 100%;
    background-color: #e2e8f1;
    .title {
      line-height: 50px;
      background-color: #eee;
      color: #999999;
      text-align: center;
      border-bottom: 1px solid #ddd;
      font-size: 15px;
    }
    .box {
      border-bottom: 1px solid #ddd;
    }
    .titleItem {
      background-color: #eeeeee;
    }
    .titleItem div {
      width: 80px;
      margin: 0 auto;
      line-height: 40px;
      color: #999999;
      font-size: 15px;
    }
    .item {
      width: 80px;
      margin: 0 auto;
      line-height: 40px;
      font-size: 14px;
      a {
        color: #666;
      }
    }
    .active {
      background-color: #fff;
      a {
        color: #0099ff;
      }
    }
  }

  .topBar {
    margin-bottom: 40px;
    .subTitle {
      width: 1050px;
      margin: 0 auto;
      font-size: 14px;
      position: relative;
    }
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }

  .filtrate {
    width: 1060px;
    height: 100%;
    margin: 0 auto;
    // margin-left: 420px;

    //  background: #f5f5f5;
    .filtrate_center {
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-top: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
    }
    .center_list_head {
      width: 100%;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      display: flex;
      justify-content: space-between;
      .center_list_head_left {
        display: flex;
        align-items: center;
        > div {
          margin-left: 10px;
        }
      }
      .center_list_head_rig {
        width: 100px;
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        font-size: 12px;
        font-family: "MicrosoftYaHeiLight";
        font-weight: 300;
        color: rgba(153, 153, 153, 1);
        margin: 7px 30px 0 0;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
      }
      .center_list_head_rig:hover {
        color: #0099ff;
      }
    }
  }
  button {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  button:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
}
</style>

